import React, { FunctionComponent } from 'react'
import { Button, Heading, Text, Modal } from '@afterpaytouch/core'
import { useTranslation } from '../../utils/convergence'
import { useCheckoutSizes } from '../../utils/responsive'
import { setShowPaymentOptionsErrorModal, useAppDispatch, useOfferDetailPBI, usePaymentOptionsError, useShowPaymentOptionsErrorModal } from '../../state'
import styles from './style.module.css'
import { TerminalErrorCode } from '../../model'
import { TrackOnMount } from '../../integrations/monitoring'
import { TrackingEvent } from '../../model/monitoring'

export const PaymentOptionsErrorModal: FunctionComponent = () => {
  const { t } = useTranslation()
  const paymentOptionsError = usePaymentOptionsError()
  const showPaymentOptionsErrorModal = useShowPaymentOptionsErrorModal()
  const { headingSize, textSize } = useCheckoutSizes()
  const dispatch = useAppDispatch()
  const offerDetailPBI = useOfferDetailPBI()
  const interval = offerDetailPBI?.numberOfInstallments
  const stillPayInTextEnabled = paymentOptionsError?.error !== TerminalErrorCode.ErrorPCL

  const onClickContinue = (): void => {
    dispatch(setShowPaymentOptionsErrorModal(false))
  }

  return (
    <Modal testNameSpace='payment-options-error' show={showPaymentOptionsErrorModal} onClose={onClickContinue}>
      <div className={styles.container}>
        <Modal.Header>
          <Heading size={headingSize}>{t(`consumerLending:paymentOptionsErrorModal.${paymentOptionsError?.error}.title`)}</Heading>
        </Modal.Header>
        <Modal.Content>
          <div className={styles.text}>
            <Text size={textSize}>{t(`consumerLending:paymentOptionsErrorModal.${paymentOptionsError?.error}.description`, { interval })}</Text>
          </div>
          {stillPayInTextEnabled && (
            <div className={styles.text}>
              <Text size={textSize} bold>
                {t(`consumerLending:paymentOptionsErrorModal.stillPayIn`, { interval })}
              </Text>
            </div>
          )}
          <Button kind='Primary' padding='Fluid' size='Large' onClick={onClickContinue} testNameSpace='payment-options-error-modal'>
            {t('consumerLending:paymentOptionsErrorModal.continue')}
          </Button>
        </Modal.Content>
      </div>
      <TrackOnMount eventName={TrackingEvent.VIEWED_NON_TERMINAL_ERROR} eventProperties={{ errorCode: paymentOptionsError?.error }} />
    </Modal>
  )
}
